import { GridOverlay } from "@material-ui/data-grid";
import React from "react";
import Spin from "../img/Spin-1s-200px.svg";
const CustomLoading = () => {
  return (
    <GridOverlay>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={Spin} alt="" style={{ backgroundColor: "white" }} />
      </div>
    </GridOverlay>
  );
};

export default CustomLoading;
